import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.38 16.39C14 16.57 13.55 16.52 13.23 16.25L9.4 13.12C9.15 12.91 9 12.6 9 12.27C9 11.94 9.14 11.63 9.4 11.42L13.19 8.25002C13.51 7.98002 13.96 7.92002 14.34 8.10002C14.72 8.28002 14.96 8.67002 14.96 9.09002L14.99 15.39C14.99 15.82 14.75 16.2 14.37 16.39H14.38Z" fill={ fill || 'currentColor' }/>
    </svg>

);
